

























































































































































































































































    import { Component, Vue } from 'vue-property-decorator'
	import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

	@Component
    export default class FormElementsPage extends Vue {
        data() {
            return {
                PageTitle: "Checkbox and radio buttons (CSS only/cross-browser)"
            }
        }
        mounted() {
            new Reveal.revealOnScrollModule()
        }
    }
